import { useParams } from "react-router-dom";

export const usePostId = () => {
	const { postId } = useParams<{ postId: string }>();

	if (!postId) {
		throw new Error("postId is required in URL params");
	}

	return { postId };
};
